exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.limit-width[data-v-0a7957c6] {\n  max-width: 1000px;\n}\nselect[data-v-0a7957c6] {\n  height:2.5rem;\n}\ninput[type=radio]:checked + label[data-v-0a7957c6] {\n  background-color: var(--theme-primary);\n  border-color: var(--theme-primary);\n  color: #FFFFFF;\n}\n@media (max-width: 992px) {\n.responsive-center[data-v-0a7957c6] {\n    margin-left:auto;\n    margin-right:auto;\n}\n}\n@media (min-width: 992px) {\n.responsive[data-v-0a7957c6] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a7957c6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/registration/SelectMultiplePhoneCoverageBillingWm.vue
// module id = 623
// module chunks = 0